<template>
    <div class="_companyinfo">
        <div class="head">
            <span class="title">单位图片</span>
            <div class="pic-list">
                <viewer :images="pics">
                    <template v-for="pic in pics" v-viewer>
                        <div class="one-pic">
                            <img :src="pic.url"/>
                            <!--<Icon type="search"></Icon>-->
                        </div>
                    </template>
                </viewer>
            </div>
        </div>
    </div>
</template>

<script>
    import $api from "@/service";

    export default {
        name : "pictures",
        data(){
            return {
                pics : [],
            }
        },
        mounted(){
            this.getCompanyPics();
        },
        methods : {
            //获取公司所有图片
            getCompanyPics(){
                let _self = this;
                $api.getCompanyPics().then(data => {
                    _self.pics = data;
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/company/baseinfo/business/Pictures.vue